export default __webpack_public_path__ + "static/media/cycling-marker.e5bbcee3.png";